import { render, staticRenderFns } from "./TaxAdministrationView.vue?vue&type=template&id=38f22da6&"
import script from "./TaxAdministrationView.vue?vue&type=script&lang=js&"
export * from "./TaxAdministrationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports